import FileInput from "components/common/input/FileInput";
import DialogBase from "components/dialog/DialogBase";
import { CategoryModel, ContextModel } from "models";
import { CommonFileModel } from "models/CommonFileModel";
import React from "react";

type PROPS = {
  ctx?: ContextModel;
  data: {
    title: string;
    target?: CategoryModel;
    breadcrumb: CategoryModel[];
    callback: (data?: {
      target?: CategoryModel;
      breadcrumb: CategoryModel[];
      name: string;
      image?: CommonFileModel;
    }) => void;
  } | null;
};

const CategoryEditDialog: React.FC<PROPS> = (props) => {
  const [imgData, setImgData] = React.useState<CommonFileModel>();
  const [categoryName, setCategoryName] = React.useState("");

  const target = props.data?.target;
  const breadcrumb = props.data?.breadcrumb ?? [];
  const callback = props.data?.callback ?? (() => {});

  // パンくずリストの長さ0の時は、大カテゴリなので、画像の入力をONにする
  const isLarge = props.data?.breadcrumb.length === 0;

  const onRegister = () => {
    if (isLarge) {
      callback({
        target,
        breadcrumb,
        name: categoryName,
        image: imgData,
      });
    } else {
      callback({ target, breadcrumb, name: categoryName });
    }
  };

  React.useEffect(() => {
    // 初期化
    if (props.data?.target) {
      const target = props.data.target;
      setImgData(target.image);
      setCategoryName(target.name);
    } else {
      setImgData({
        file_name: "",
        file_data: "",
        image_url: "",
      });
      setCategoryName("");
    }
  }, [props.data]);

  return (
    <DialogBase
      modalIsOpen={!!props.data}
      title={props.data?.title ?? ""}
      close={callback}
    >
      <div className="m-8 flex flex-col gap-4 min-w-[32rem]">
        {isLarge && (
          <div className="flex items-start gap-4">
            <div className="w-3/12 whitespace-nowrap">画像</div>
            <div className="max-w-[75%]">
              <FileInput
                data={imgData}
                preview
                ctx={props.ctx}
                name="カテゴリ画像"
                maxSize={1}
              />
            </div>
          </div>
        )}
        <div className="flex items-center gap-4">
          <div className="w-3/12 whitespace-nowrap">カテゴリ名</div>
          <input
            className="flex-1"
            value={categoryName}
            onChange={(e) => {
              setCategoryName(e.target.value);
            }}
          />
        </div>

        <div className="flex justify-center">
          <button className="primary px-4 py-2" onClick={onRegister}>
            {props.data?.target ? "更新" : "登録"}
          </button>
        </div>
      </div>
    </DialogBase>
  );
};

export default CategoryEditDialog;
